const colors = Object.freeze({
  neutral100: 'var(--neutral-100)',
  neutral80: 'var(--neutral-80)',
  neutral60: 'var(--neutral-60)',
  neutral20: 'var(--neutral-20)',
  neutral20Adjusted: 'var(--neutral-20-adjusted)',
  neutral10: 'var(--neutral-10)',
  neutral10Adjusted: 'var(--neutral-10-adjusted)',
  neutral10Background: 'var(--neutral-10-background)',
  neutral5: 'var(--neutral-5)',
  neutralInverted100: 'var(--neutral-inverted-100)',
  neutralInverted80: 'var(--neutral-inverted-80)',
  neutralInverted60: 'var(--neutral-inverted-60)',
  neutralInverted20: 'var(--neutral-inverted-20)',
  neutralInverted10: 'var(--neutral-inverted-10)',
  neutralInverted5: 'var(--neutral-inverted-5)',
  red100: 'var(--red-100)',
  red80: 'var(--red-80)',
  red60: 'var(--red-60)',
  red20: 'var(--red-20)',
  red10: 'var(--red-10)',
  red5: 'var(--red-5)',
  orange100: 'var(--orange-100)',
  orange80: 'var(--orange-80)',
  orange60: 'var(--orange-60)',
  orange20: 'var(--orange-20)',
  orange10: 'var(--orange-10)',
  orange5: 'var(--orange-5)',
  purple100: 'var(--purple-100)',
  purple80: 'var(--purple-80)',
  purple60: 'var(--purple-60)',
  purple20: 'var(--purple-20)',
  purple10: 'var(--purple-10)',
  purple5: 'var(--purple-5)',
  green100: 'var(--green-100)',
  green80: 'var(--green-80)',
  green60: 'var(--green-60)',
  green20: 'var(--green-20)',
  green10: 'var(--green-10)',
  green5: 'var(--green-5)',
  white100: 'var(--white-100)',
  white80: 'var(--white-80)',
  white60: 'var(--white-60)',
  white20: 'var(--white-20)',
  white10: 'var(--white-10)',
  white5: 'var(--white-5)',
  black100: 'var(--black-100)',
  black80: 'var(--black-80)',
  black60: 'var(--black-60)',
  black20: 'var(--black-20)',
  black10: 'var(--black-10)',
  black5: 'var(--black-5)',
  chart1: 'var(--chart-1)',
  chart2: 'var(--chart-2)',
  chart3: 'var(--chart-3)',
  chart4: 'var(--chart-4)',
  chart5: 'var(--chart-5)',
  chart6: 'var(--chart-6)',
  chart7: 'var(--chart-7)',
  chart8: 'var(--chart-8)',
  chart9: 'var(--chart-9)',
  chart10: 'var(--chart-10)',
  chart11: 'var(--chart-11)',
  chartMono1: 'var(--chart-mono-1)',
  chartMono2: 'var(--chart-mono-2)',
  chartMono3: 'var(--chart-mono-3)',
  chartMono4: 'var(--chart-mono-4)',
  chartMono5: 'var(--chart-mono-5)',
  chartMono6: 'var(--chart-mono-6)',
})

type Color = keyof typeof colors

export { colors }
export type { Color }
